import React from 'react'
import { Link } from 'react-router-dom'
import SEO from './SEO';
import './DealDetailPage.css';

const CONTACT_EMAIL = "dinodealz18@gmail.com";

function PrivacyPolicy() {
  return (
    <div className="detail-page">
      <SEO title="Privacy Policy" description="How DinoDealz handles your information." />
      <div className="detail-layout page-narrow">
        <main>
          <nav className="detail-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>›</span>
            <span>Privacy Policy</span>
          </nav>

          <section className="page-card policy">
            <h1>Privacy Policy</h1>
            <p className="page-intro">Last updated: October 8, 2026</p>

            <p>At www.dinodealz.com, the privacy of our visitors is of extreme importance to us.</p>

            <h2>What we collect</h2>
            <p>
              Only what you send us: your email if you sign up for deals, and your name, email and message if you
              contact us. We use it only to send deals or reply to you. We never sell your information.
            </p>

            <h2>Cookies and affiliate links</h2>
            <p>
              DinoDealz does not use tracking cookies, ads or analytics. Some links are affiliate links: if you buy
              through them we may earn a small commission, and the store (for example Amazon) may set its own cookies.
              As an Amazon Associate we earn from qualifying purchases.
            </p>

            <h2>Contact us</h2>
            <p>
              To unsubscribe, ask a question, or have your information deleted, email us
              at <a href={"mailto:" + CONTACT_EMAIL}>{CONTACT_EMAIL}</a>.
            </p>
          </section>
        </main>
      </div>
    </div>
  )
}

export default PrivacyPolicy
